const sidescrollers: Array<HTMLElement> = [
  ...document.querySelectorAll<HTMLElement>(".sidescroll"),
];

const setupSidescrollers = () => {
  if (sidescrollers.length === 0) return;

  sidescrollers.forEach((sidescroller) => {
    const sidescrollList: HTMLElement | null = sidescroller.querySelector(".sidescroll-list");
    const scrollbar = sidescroller.querySelector(".sidescroll-scrollbar") as HTMLElement;
    const bar = scrollbar?.querySelector(".scrollbar-bar") as HTMLElement;
    const controls: HTMLElement | null = sidescroller.querySelector(".sidescroll-controls");
    const prevButton: HTMLButtonElement | null = sidescroller.querySelector(".prev-card");
    const nextButton: HTMLButtonElement | null = sidescroller.querySelector(".next-card");

    const getScrollAmount = (sidescrollList: HTMLElement) => {
      const firstChild = sidescrollList.children[0] as HTMLElement;
      return firstChild ? firstChild.offsetWidth : 0;
    };

    function updateControlsVisibility() {
      if (!sidescrollList || !controls) return;
      if (sidescrollList.scrollWidth <= sidescrollList.clientWidth) {
        controls.style.display = "none";
        scrollbar.style.display = "none";
      } else {
        controls.style.display = "";
        scrollbar.style.display = "";
      }
    }

    nextButton?.addEventListener("click", () => {
      if (prevButton) prevButton.disabled = false;
      const scrollPos: number | undefined = sidescrollList?.scrollLeft;
      const scrollAmount = sidescrollList ? getScrollAmount(sidescrollList) : 0;
      const newScrollPos = scrollPos !== undefined ? scrollPos + scrollAmount : 0;
      if (sidescrollList) scroll(sidescrollList, newScrollPos);
    });

    prevButton?.addEventListener("click", () => {
      const scrollPos: number | undefined = sidescrollList?.scrollLeft;
      const scrollAmount = sidescrollList ? getScrollAmount(sidescrollList) : 0;
      const newScrollPos = scrollPos !== undefined ? scrollPos - scrollAmount : 0;
      if (sidescrollList) scroll(sidescrollList, newScrollPos);
    });

    function scroll(sidescrollList: HTMLElement, scrollPos: number) {
      sidescrollList.scroll({
        left: scrollPos,
        behavior: "smooth",
      });
    }

    function updateSidescrollScrollbar() {
      const list = sidescroller.querySelector(".sidescroll-list") as HTMLElement;

      if (!list || !bar || !scrollbar) return;

      const scrollbarWidth = scrollbar.offsetWidth;
      const padding = 16;
      const trackWidth = scrollbarWidth - 2 * padding;

      const scrollLeft = list.scrollLeft;
      const scrollWidth = list.scrollWidth;
      const clientWidth = list.clientWidth;

      const progress = scrollLeft / (scrollWidth - clientWidth);
      const barWidth = (clientWidth / scrollWidth) * trackWidth;
      const barLeft = progress * (trackWidth - barWidth);

      bar.style.width = `${barWidth}px`;
      bar.style.transform = `translateX(${barLeft}px)`;
    }

    if (sidescrollList) {
      sidescrollList.addEventListener("scroll", updateSidescrollScrollbar);
    }

    setTimeout(updateSidescrollScrollbar, 100);
    window.addEventListener("resize", updateSidescrollScrollbar);
    updateControlsVisibility();
    window.addEventListener("resize", updateControlsVisibility);
  });
};

setupSidescrollers();
